<main class="mat-body">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                <div class="detail my-5 px-0 p-sm-4 pb-4" *ngIf="product">
                    <h1 class="product-name">{{ product.name }}</h1>

                    <div class="row justify-content-between mx-4">
                        <div class="col-12 col-md-5 mb-3 card-detail">
                            <i class="icon-money-in-hand"></i>
                            <h2 class="mat-title text-blue font-weight-bold mt-2 mb-3">
                                {{ 'product.detail.management-commission'|translate }}
                            </h2>
                            <h3 class="mat-display-1 text-blue font-weight-bold mb-3">{{ product.managementFee|number:'1.2-2' }} %</h3>
                            <p class="mb-0">
                                {{ 'product.detail.depositary-commission'|translate }}
                                <strong *ngIf="product.custodyFee === -10000"> -- </strong>
                                <strong *ngIf="product.custodyFee !== -10000">{{ product.custodyFee|number:'1.2-2' }}%</strong>
                            </p>
                        </div>

                        <div class="col-12 col-md-5 mb-3 card-detail">
                            <i class="icon-pie"></i>
                            <h2 class="mat-title text-blue font-weight-bold mt-2 mb-3">
                                {{ 'product.detail.liquidation-value'|translate }}
                                <ng-container *ngIf="product.lastPriceDate"
                                    >{{ product.lastPriceDate?.toDate()|date:'dd-MM-yyyy' }}</ng-container
                                >
                            </h2>
                            <h3 class="mat-display-1 text-blue font-weight-bold mb-3">{{ product.lastPrice|number:'1.2-2' }} €</h3>
                            <p class="mb-0" *ngIf="product.liquidityDescription">
                                <strong>{{ product.liquidityDescription }}</strong>
                            </p>
                        </div>

                        <div class="col-12 col-md-5 mb-3 card-detail">
                            <i class="icon-money"></i>
                            <h2 class="mat-title text-blue font-weight-bold mt-2 mb-3">{{ 'product.detail.min-investment'|translate }}</h2>
                            <h3 class="mat-display-1 text-blue font-weight-bold mb-3">{{ product.minimumInvestment|number:'1.2-2' }} €</h3>
                        </div>

                        <div class="col-12 col-md-5 mb-3 card-detail">
                            <i class="icon-euro"></i>
                            <h2 class="mat-title text-blue font-weight-bold mt-2 mb-3">{{ 'product.detail.category'|translate }}</h2>
                            <h3 class="mat-display-1 text-blue font-weight-bold mb-3">{{ product.assetClass }}</h3>
                        </div>

                        <div class="col-12 px-0" *ngIf="product.description">
                            <div class="row">
                                <div class="col-12">
                                    <h6 class="mat-subheading-1 font-weight-bold text-blue mb-1">
                                        {{ 'product.detail.features'|translate }}
                                    </h6>
                                    <div class="container-panel" [class.full]="showDescription">
                                        <p class="mb-0">{{ product.description }}</p>
                                        <button
                                            type="button"
                                            class="btn-toggle mat-elevation-z0"
                                            mat-icon-button
                                            (click)="toggleDescription()"
                                        >
                                            <i *ngIf="!showDescription" class="material-icons">add_circle_outline</i>
                                            <i *ngIf="showDescription" class="material-icons">remove_circle_outline</i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 px-0" *ngIf="documents && documents.length > 0">
                            <div class="row" [class.mt-3]="product.description">
                                <div class="col-12">
                                    <h6 class="mat-subheading-1 mb-1">{{ 'product.detail.documentation'|translate }}</h6>
                                    <ul class="document-list mb-0">
                                        <ng-template ngFor let-document [ngForOf]="documents">
                                            <li class="document-list-item d-flex align-items-center justify-content-between">
                                                <strong class="text-blue">{{ document.title|translate }}</strong>

                                                <div class="d-flex align-items-center">
                                                    <span class="mr-3">PDF</span>
                                                    <button
                                                        type="button"
                                                        class="mat-elevation-z0"
                                                        mat-icon-button
                                                        (click)="downloadDocument(document.url)"
                                                    >
                                                        <i class="icon-download"></i>
                                                    </button>
                                                </div>
                                            </li>
                                        </ng-template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
